import { render, staticRenderFns } from "./bonusBase.vue?vue&type=template&id=fc4fe44a&scoped=true&"
import script from "./bonusBase.vue?vue&type=script&lang=js&"
export * from "./bonusBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4fe44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4fe44a')) {
      api.createRecord('fc4fe44a', component.options)
    } else {
      api.reload('fc4fe44a', component.options)
    }
    module.hot.accept("./bonusBase.vue?vue&type=template&id=fc4fe44a&scoped=true&", function () {
      api.rerender('fc4fe44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/bonus/bonusBase.vue"
export default component.exports